import React from "react";
import {HeroImageSection} from "../components/common/HeroImageSection";
import {SideTitleSliderSection} from "../components/SideTitleSliderSection";
import SectionDivider from "../components/common/SectionDivider";

const SportsPage: React.FC = () => {

    const swimmingSlides = [
        {
            image: '/images/swimming_1.webp'
        },
        {
            image: '/images/swimming_2.webp'
        }
    ]

    const badmintonSlides = [
        {
            image: '/images/badminton_1.webp'
        },
        {
            image: '/images/badminton_2.webp'
        }
    ]

    const pickleballSlides = [
        {
            image: '/images/pickleball_1.jpeg'
        },
        {
            image: '/images/pickleball_2.webp'
        }
    ]

    const basketballSlides = [
        {
            image: '/images/basketball_1.webp'
        },
        {
            image: '/images/basketball_2.webp'
        }
    ]

    const cricketSlides = [
        {
            image: '/images/cricket_1.webp'
        },
        {
            image: '/images/cricket_2.webp'
        }
    ]

    const footballSlides = [
        {
            image: '/images/football_1.webp'
        },
        {
            image: '/images/football_2.webp'
        }
    ]

    const poolLoungeSlides = [
        {
            image: '/images/pool_1.webp'
        },
        {
            image: '/images/pool_2.webp'
        }
    ]

    const tableTennisSlides = [
        {
            image: '/images/table_tennis_1.webp'
        },
        {
            image: '/images/table_tennis_2.webp'
        }
    ]

    return (
        <div className="bg-dark-mode text-ivory">
            <HeroImageSection
                image="/images/badminton_1.webp"
                text="SPORTS FACILITIES"
                nextSectionId="swimming-pool-section"
            />
            <SideTitleSliderSection
                id="swimming-pool-section"
                title="SWIMMING POOL"
                description="Dive into unmatched leisure with our signature swimming pool."
                slides={swimmingSlides}/>
            <SideTitleSliderSection
                id="badminton-section"
                title="BADMINTON"
                description="Step onto international-standard courts built for champions."
                slides={badmintonSlides}
                isLeftAligned={false}/>
            <SectionDivider/>
            <SideTitleSliderSection
                id="pickleball-section"
                title="PICKLEBALL"
                description="Engage in the newest global sports craze on premium courts at All Aces Club."
                slides={pickleballSlides}/>
            <SideTitleSliderSection
                id="basketball-section"
                title="BASKETBALL"
                description="Step into our indoor basketball arena designed for both casual games and serious players."
                slides={basketballSlides}
                isDark={true} isLeftAligned={false}/>
            <SectionDivider onDark={true}/>
            <SideTitleSliderSection
                id="cricket-section"
                title="CRICKET ARENA"
                description="A dedicated arena for India’s most loved sport."
                slides={cricketSlides}
                isDark={true}/>
            <SectionDivider onDark={true}/>
            <SideTitleSliderSection
                id="football-section"
                title="FOOTBALL"
                description="The perfect pitch for kids, teens, and adults to stay active and competitive."
                slides={footballSlides}
                isDark={true} isLeftAligned={false}/>
            <SideTitleSliderSection
                id="pool-lounge-section"
                title="POOL LOUNGE"
                description="A refined space for leisure, enjoy pool, darts, and timeless lounge vibes."
                slides={poolLoungeSlides}/>
            <SectionDivider/>
            <SideTitleSliderSection
                id="table-tennis-section"
                title="TABLE TENNIS"
                description="From casual rallies to competitive duels, every game is a thrill."
                slides={tableTennisSlides}/>
        </div>
    );
};

export default SportsPage;